import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {RedirectResponse} from './contracts'

export async function apiRetryMigration(): Promise<RedirectResponse> {
  const apiMetadata = getApiMetadata('memex-migration-retry-api-data')
  const {data} = await fetchJSON<RedirectResponse>(apiMetadata.url, {
    method: 'POST',
    token: apiMetadata.token,
  })

  return {redirectUrl: data?.redirectUrl}
}
